import React from "react";
import { Link } from "react-router-dom";
import { LOGO_URL } from "../lib/config";
import { openCookiePreferences } from "./CookieBanner";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-fp-bg py-12 px-5 md:px-8" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="Fanta Partenope" className="w-12 h-12" />
              <div>
                <div className="font-heading font-black silver-gradient">FANTA PARTENOPE</div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-fp-cyan">ASD · Casalnuovo (NA)</div>
              </div>
            </div>
            <p className="mt-5 text-white/50 text-sm max-w-xs">
              Il torneo più elettrico d'Italia. Edizione 2026/2027.
            </p>
            <div className="mt-5 text-xs text-white/35 leading-relaxed max-w-sm">
              <div>ASD Fanta Partenope · P.IVA 10774701212</div>
              <div>Iscrizione CONI n. 31102317</div>
              <div>Via Vittorio Emanuele Terzo, 80013 Casalnuovo di Napoli (NA)</div>
              <div className="mt-2">PEC: <a href="mailto:fantapartenope@pec.it" className="hover:text-fp-cyan">fantapartenope@pec.it</a></div>
            </div>
          </div>
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-white/50 font-heading font-semibold">Naviga</div>
            <ul className="mt-4 space-y-2 text-sm">
              <li><a href="#premi" className="text-white/70 hover:text-fp-cyan">Premi</a></li>
              <li><a href="#leghe" className="text-white/70 hover:text-fp-cyan">Leghe</a></li>
              <li><a href="#regolamento" className="text-white/70 hover:text-fp-cyan">Regolamento</a></li>
              <li><a href="#classifica" className="text-white/70 hover:text-fp-cyan">Classifica</a></li>
              <li><Link to="/gallery" className="text-white/70 hover:text-fp-cyan">Gallery</Link></li>
              <li><a href="#sponsor" className="text-white/70 hover:text-fp-cyan">Sponsor</a></li>
            </ul>
          </div>
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-white/50 font-heading font-semibold">Legal</div>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/privacy" className="text-white/70 hover:text-fp-cyan" data-testid="footer-privacy">Privacy Policy</Link></li>
              <li><Link to="/termini" className="text-white/70 hover:text-fp-cyan" data-testid="footer-termini">Termini e Condizioni</Link></li>
              <li><Link to="/cookie" className="text-white/70 hover:text-fp-cyan" data-testid="footer-cookie">Cookie Policy</Link></li>
              <li>
                <button
                  onClick={openCookiePreferences}
                  className="text-white/70 hover:text-fp-cyan text-left bg-transparent border-0 p-0 cursor-pointer font-body text-sm"
                  data-testid="footer-cookie-preferences"
                >
                  Preferenze Cookie
                </button>
              </li>
              <li><Link to="/register" className="text-white/70 hover:text-fp-cyan">Iscriviti</Link></li>
              <li><a href="#contatti" className="text-white/70 hover:text-fp-cyan">Contatti</a></li>
              <li><Link to="/admin/login" className="text-white/40 hover:text-fp-cyan text-xs">Area Admin</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <div>© {new Date().getFullYear()} ASD Fanta Partenope · Tutti i diritti riservati</div>
          <div>Powered by passion · Made in Napoli</div>
        </div>
      </div>
    </footer>
  );
}
